import { getCountries, getCountryCallingCode } from 'libphonenumber-js';
import {
    countriesNotSupported,
    countriesPrioritized,
} from '../../utils/constants';
import { appUrl } from '../../utils/variables';

export function loadCountriesCodeDropdown(screen) {
    let codes = [];
    const countries = getCountries();

    countries.forEach((country) => {
        if (!countriesNotSupported.includes(country)) {
            let code = `
            <li class="phone__countryCode--option" data-country="${country}" data-country-code="${getCountryCallingCode(
                country
            )}" data-screen="${screen}">
                <img src="${appUrl}/assets/images/svg/${country.toLowerCase()}.svg" class="flag-icon">
                <span style="margin-left: 6px">+${getCountryCallingCode(
                    country
                )}</span>
            </li>
            `;
            if (countriesPrioritized.includes(country)) {
                codes.unshift(code);
            } else codes.push(code);
        }
    });

    return codes.join(' ');
}
